import { Component } from '@angular/core';

@Component({
  selector: 'app-cards6-examples-38',
  templateUrl: './cards6-examples-38.component.html'
})
export class Cards6Examples38Component {}
